import { AsyncSelect } from '@atlaskit/select';
import { ComponentWithAnalytics } from '@atlassian/jira-analytics-web-react/src';

export const AsyncSelectWithAnalytics = ComponentWithAnalytics('select', {
	onChange: 'changed',
})(AsyncSelect);
